(function () {
  function init() {
    var footer = document.querySelector(".ws-footer");
    if (!footer) return;

    // Mobile accordion toggles (no-op on desktop: CSS disables pointer events)
    footer.querySelectorAll(".ws-footer__col-toggle").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var col = btn.closest(".ws-footer__col");
        if (!col) return;
        var open = col.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });

    // Keep footer clear of the mobile sticky buy bar when present
    function setStickyPad() {
      var sticky = document.querySelector(".ws-sticky");
      var h = 0;
      if (sticky && window.getComputedStyle(sticky).display !== "none") {
        h = sticky.offsetHeight || 0;
      }
      footer.style.setProperty("--ws-sticky-pad", h + "px");
    }
    setStickyPad();
    window.addEventListener("resize", setStickyPad);
    setTimeout(setStickyPad, 1500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
